module.exports = __webpack_public_path__ + "static/media/strongher3.67200264.jpg";